import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  createButtonObject,
  DISPLAY_TYPE,
} from '../../organisms/BlockInteractions';
import BlockFetcher from '../../hocs/BlockFetcher/BlockFetcher';

import { Icons } from '../../atoms/SVG';
import { Namespace } from '../../../translation/namespace';
import ExternalLinkDetailsView, { ExternalLinkDetailsViewProps } from './partials/ExternalLinkDetailsView';
import { ExternalLinkDetailsForm, ExternalLinkDetailsFormProps } from './forms/ExternalLinkDetailsForm';
import { RefreshCallback } from '../../../_lib/FetchContainer';
import { DefaultView, EditView, Views } from '../../../types/BlockWithViews';

const ExternalLinkDefaultView = BlockFetcher()(ExternalLinkDetailsView);
const ExternalLinkEditView = BlockFetcher()(ExternalLinkDetailsForm);

type ExternalLinkDetailsProps = {
  elementType: string;
  uuid: string;
  refresh: RefreshCallback;
} & Views<DefaultView<ExternalLinkDetailsViewProps> & EditView<ExternalLinkDetailsFormProps>>;

export function ExternalLinkDetails({ elementType, uuid, views, activeView, refresh }: ExternalLinkDetailsProps) {
  const { t } = useTranslation(Namespace.ExternalLinkDetails);

  const createButtonsObject = () => {
    return createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.ExternalLinkDetails}:edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      <ExternalLinkEditView
        additionalProps={{
          refreshBlock: refresh,
          translationNamespace: `${Namespace.ExternalLinkDetails}:edit`,
        }}
        {...views.edit}
      />,
    );
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      buttons={createButtonsObject()}
      views={views}
      activeView={activeView}
      refreshBlock={refresh}
    >
      <ExternalLinkDefaultView {...views.default} />
    </BlockInteractions>
  );
}
